// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"90dd41e0","200":"45a9b0ea","260":"8178168a","518":"51b501e3","522":"faf7e70e","593":"cfa52076","632":"5c857992","697":"dccdad48","754":"cb347e93","827":"6e4e380e","873":"6182d6e9","945":"07edd13b","969":"84c0861a"}[chunkId] + ".chunk.js";
};